type TAmountCurrency = {
  amount: number;
  currency: string;
};

type TSummaryItem = {
  label?: string;
  value: number;
};

export type TPaymentOrder = {
  id: string;
  items: TOrderItem[];
  paymentAmount: TAmountCurrency;
  summary: {
    fees?: TSummaryItem;
    shipping?: TSummaryItem;
    totalAmount: TSummaryItem;
  };
};

export type TOrderItem = {
  id?: number;
  name: string;
  description: string;
  price: number;
  amount: number;
  thumbnail?: string;
};

export enum ERequestedPaymentMethod {
  CARD = 'CARD',
}

export type TPaymentDetails = {
  mode: 'REDIRECT' | 'EMBEDDED';
  requestedPaymentMethod?: ERequestedPaymentMethod;
  paymentExternalId: string;
  order: TPaymentOrder;
  paymentInfo: {
    merchant: {
      logo: string;
      name: string;
      successUrl: string;
      cancelUrl: string;
      url: string;
    };
  };
};

export type TPaymentLinkDetails = {
  link: string;
  description: string;
  amount: number;
  currency: string;
  country: string;
  externalId: string;
  appId: string;
};

export type TPaymentRequestData = {
  amount: number;
  country: string;
  currency: string;
  appId: string;
  description?: string;
  paymentLink?: string;
};

export type TPaymentResponseData = {
  paymentExternalId: string;
  redirectUrl: string;
  status: string;
};
